<template>
  <div class="slider-container">
    <ul class="slider">
      <li
        class="slider__slide"
        v-for="(imageSrc, index) in imageSources"
        :key="index"
      >
        <div class="slide__content">
          <img class="image-center" :src="imageSrc" alt="" />
        </div>
      </li>
      <li
        class="slider__slide"
        v-for="(imageSrc, index) in imageSources"
        :key="index"
      >
        <div class="slide__content">
          <img class="image-center" :src="imageSrc" alt="" />
        </div>
      </li>
      <li
        class="slider__slide"
        v-for="(imageSrc, index) in imageSources"
        :key="index"
      >
        <div class="slide__content">
          <img class="image-center" :src="imageSrc" alt="" />
        </div>
      </li>
      <li
        class="slider__slide"
        v-for="(imageSrc, index) in imageSources"
        :key="index"
      >
        <div class="slide__content">
          <img class="image-center" :src="imageSrc" alt="" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageSources: [
        require("@/assets/accreditations/hse-asbestos-logo.svg"),
        require("@/assets/accreditations/investors-in-people.svg"),
        require("@/assets/accreditations/nqa-logo.svg"),
        require("@/assets/accreditations/acad-logo.svg"),
        require("@/assets/accreditations/environment-agency-logo.svg"),
        require("@/assets/accreditations/fors-logo.svg"),
        require("@/assets/accreditations/ukata-logo.svg"),
        require("@/assets/accreditations/construction-online.svg"),
        require("@/assets/accreditations/ciras-logo.svg"),
        require("@/assets/accreditations/bsc-logo.svg"),
      ],
    };
  },
};
</script>

<style scoped>
.slider {
  --slider-inner-width: 5000px;
  --slider-speed: 50s;
}

@keyframes scroll {
  0% {
    transform: translateX(-5%);
  }
  100% {
    transform: translateX(calc((0px - var(--slider-inner-width)) - 5%));
  }
}

.slider {
  -webkit-transform: translate3d(0, 0, 0);
  animation: scroll linear infinite var(--slider-speed);
  width: calc(2 * var(--slider-inner-width));
  transition: animation-play-state ease 0.3s;
}

.slider:hover {
  animation-play-state: paused;
}

.slider-container {
  /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2); */
  height: 100px;
  background: transparent;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.slider-container .slider {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
}

.slider-container .slider__slide {
  height: 100px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-container .slide__content {
  color: white;
}

.slider-container .image-center {
  max-width: 100%;
  max-height: 75px;
  display: block;
  margin: 0 auto;
}
</style>
